var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recyle-page",on:{"click":_vm.preview}},[_c('img',{staticClass:"recyle-img",attrs:{"src":_vm.imgSrc,"alt":"回收内容","loading":"lazy","draggable":"false"}})])}
var staticRenderFns = []

export { render, staticRenderFns }